module.exports = __webpack_public_path__ + "media/images/icons/SVG/064-c2bbd3595f7de20856c9b8463a6029c2.svg";